// production api
export const BASE_URL = "https://api.paynestschools.ae/api";
export const BASE_IMG = "https://api.paynestschools.ae/upload/";
export const FE_URL = "https://paynestschools.ae/";
export const ReCAPTCHA_SITE_KEY = "6LdXrS0mAAAAAPctioMmglMdy8d0aI6kgPmMFGJr";

export const SIGN_IN = "admin/auth/login";
export const GET_USER_INFO = "admin/auth/getUserInfo";
export const GET_COUNTRIES = "countries";
export const UPDATE_USER_INFO = "admin/auth/updateUserInfo";
export const GET_STUDENT_BALANCE = "student/getstudentbalance";
export const GET_STUDENT_TRANSACTIONS = "student/transactions";

export const INITIATE_PAYMENT = "transaction/initiatePayment";

export const FORGOT_PASSWORD = "admin/auth/forgotPassword";
export const VERIFY_OTP = "admin/auth/verifyOtp";
export const RESEND_OTP = "admin/auth/resendOtp";
export const UPDATE_FORGOT_PASSWORD = "admin/auth/updateForgotPassword";
export const RESET_PASSWORD = "admin/resetPassword";

export const CHECK_USER_SCHOOL = "admin/checkUserSchool";
export const INVOICES = "admin";
export const LIST_SCHOOLS = "school/all";
export const LIST_BANKS = "accounts/schoolAccounts";
export const DELETE_BANK = "accounts/delete";
export const FETCH_BANK = "accounts/byId";
export const PRIORITY_BANK = "accounts/priorityAccounts";
export const ACCOUNTS = "accounts";
export const SCHOOL_BY_ID = "school/byId";
export const SCHOOL_BY_ID_FOR_PAYMENT = "school/byIdForPayment";

export const LIST_NOTIFICATIONS = "notification/all";

export const TOP_BAR_USER_INFO = "admin/topBarUserInfo";
export const GLOBAL_SEARCH = "admin/globalSearch";
export const GET_ONLINE_USERS = "admin/onlineUsers";

export const ADD_INVOICE = "student/addInvoice";
export const UPDATE_INVOICE = "parent/updateInvoice";
export const ADD_INVOICE_CSV = "admin/bulkInvoice";
export const ADD_BALANCE_CSV = "admin/bulkBalance";
export const NOTIFY_PARENTS_NOTIFICATIONS = "admin/notifyParents";
export const LIST_STUDENTS = "admin/listStudents";
export const LIST_BALANCE = "admin/listBalance";
export const STUDENT = "student";
export const SEARCH_STUDENT = "student/all";
export const STUDENT_CURENT_INVOICE = "parent/currentInvoice";
export const CREATE_USER = "admin/createUser";
export const EDIT_USER = "admin/editUser";
export const DELETE_USER = "admin/deleteUser";
export const UPLOAD_STUDENT_PROFILE_PIC = "student/uploadPic";

export const SCHOOL = "school";
export const BANK = "bank";

export const STUDENT_STATS = "admin/stats";
export const ADD_STUDENT_CSV = "student/csvAddStudents";
export const STUDENT_INVOICES = "student/vouchers";
export const STUDENT_BALANCE = "student/add-balance";
export const UPDATE_STUDENT_CSV = "student/updateStudentBulk";
export const SYNC_ERP_STUDENTS = "student/syncErpStudents";
export const CHECK_SCHOOL_SYNC_ERP_STATUS = "student/checkSchoolSyncStatus";
export const SYNC_ERP_FEE_WITH_ERP = "student/syncSchoolFeeWithErp";

export const LIST_TRANSACTIONS = "admin/transactions";
export const DELETE_TRANSACTIONS = "admin/deleteTransactions";
export const FILTER_TRANSACTIOSN = "admin/transactions";
export const FETCH_TRANSACTION = "transaction";
export const GET_TRANSACTION_BY_ORDER_ID = "transaction/byOrderId";

export const GET_TOTAL_FEE_VS_PENDING = "dashboard/getTotalFeeVsPending";
export const GET_TOTAL_TRANSACTIONS_CHARTS =
  "dashboard/getTotalTransactionsChart";

export const amountFormat = (amount) => {
  let formatter = new Intl.NumberFormat("en-Us", {
    style: "currency",
    currency: "AED",
  });
  let val = formatter.format(amount);
  return val.substr(0, val.indexOf("."));
};
export const STATS = [
  {
    id: "0",
    name: "text_total_students",
    value: "0",
    top: null,
    maxWidth: 74,
  },
  {
    id: "1",
    name: "text_students_with_payments_pending",
    value: "0",
    top: null,
    maxWidth: 227,
  },
  {
    id: "2",
    name: "text_total_transactions_received",
    value: "0",
    top: null,
    maxWidth: 154,
  },
  {
    id: "3",
    name: "text_total_amounts_received",
    value: "0",
    top: "AED",
    maxWidth: 116,
  },
  {
    id: "4",
    name: "text_total_amounts_pending",
    value: "0",
    top: "AED",
    maxWidth: 116,
  },
];

export const RELIGIONS_LIST = [
  {
    value: "islam",
    label: "Islam",
  },
  {
    value: "hinduism",
    label: "Hinduism",
  },
  {
    value: "buddhism",
    label: "Buddhism",
  },
  {
    value: "christianity",
    label: "Christianity",
  },
  {
    value: "judasim",
    label: "Judasim",
  },
  {
    value: "irreligion",
    label: "Irreligion",
  },
];

export const SECTIONS = [
  {
    value: "A",
    label: "A",
  },
  {
    value: "B",
    label: "B",
  },
  {
    value: "C",
    label: "C",
  },
  {
    value: "D",
    label: "D",
  },
  {
    value: "E",
    label: "E",
  },
];

export const GRADES = [
  {
    value: "1",
    label: "1",
  },
  {
    value: "2",
    label: "2",
  },
  {
    value: "3",
    label: "3",
  },
  {
    value: "4",
    label: "4",
  },
  {
    value: "5",
    label: "5",
  },
  {
    value: "6",
    label: "6",
  },
  {
    value: "7",
    label: "7",
  },
  {
    value: "8",
    label: "8",
  },
  {
    value: "9",
    label: "9",
  },
  {
    value: "10",
    label: "10",
  },
];

export const COUNTRIES = [
  {
    value: "Pakistan",
    label: "Pakistan",
  },
  {
    value: "India",
    label: "India",
  },

  { value: "afghan", label: "Afghan" },
  { value: "albanian", label: "Albanian" },
  { value: "algerian", label: "Algerian" },
  { value: "american", label: "American" },
  { value: "andorran", label: "Andorran" },
  { value: "angolan", label: "Angolan" },
  { value: "antiguans", label: "Antiguans" },
  { value: "argentinean", label: "Argentinean" },
  { value: "armenian", label: "Armenian" },
  { value: "australian", label: "Australian" },
  { value: "austrian", label: "Austrian" },
  { value: "azerbaijani", label: "Azerbaijani" },
  { value: "bahamian", label: "Bahamian" },
  { value: "bahraini", label: "Bahraini" },
  { value: "bangladeshi", label: "Bangladeshi" },
  { value: "barbadian", label: "Barbadian" },
  { value: "barbudans", label: "Barbudans" },
  { value: "batswana", label: "Batswana" },
  { value: "belarusian", label: "Belarusian" },
  { value: "belgian", label: "Belgian" },
  { value: "belizean", label: "Belizean" },
  { value: "beninese", label: "Beninese" },
  { value: "bhutanese", label: "Bhutanese" },
  { value: "bolivian", label: "Bolivian" },
  { value: "bosnian", label: "Bosnian" },
  { value: "brazilian", label: "Brazilian" },
  { value: "british", label: "British" },
  { value: "bruneian", label: "Bruneian" },
  { value: "bulgarian", label: "Bulgarian" },
  { value: "burkinabe", label: "Burkinabe" },
  { value: "burmese", label: "Burmese" },
  { value: "burundian", label: "Burundian" },
  { value: "cambodian", label: "Cambodian" },
  { value: "cameroonian", label: "Cameroonian" },
  { value: "canadian", label: "Canadian" },
  { value: "cape verdean", label: "Cape Verdean" },
  { value: "central african", label: "Central African" },
  { value: "chadian", label: "Chadian" },
  { value: "chilean", label: "Chilean" },
  { value: "chinese", label: "Chinese" },
  { value: "colombian", label: "Colombian" },
  { value: "comoran", label: "Comoran" },
  { value: "congolese", label: "Congolese" },
  { value: "costa rican", label: "Costa Rican" },
  { value: "croatian", label: "Croatian" },
  { value: "cuban", label: "Cuban" },
  { value: "cypriot", label: "Cypriot" },
  { value: "czech", label: "Czech" },
  { value: "danish", label: "Danish" },
  { value: "djibouti", label: "Djibouti" },
  { value: "dominican", label: "Dominican" },
  { value: "dutch", label: "Dutch" },
  { value: "east timorese", label: "East Timorese" },
  { value: "ecuadorean", label: "Ecuadorean" },
  { value: "egyptian", label: "Egyptian" },
  { value: "emirian", label: "Emirian" },
  { value: "equatorial guinean", label: "Equatorial Guinean" },
  { value: "eritrean", label: "Eritrean" },
  { value: "estonian", label: "Estonian" },
  { value: "ethiopian", label: "Ethiopian" },
  { value: "fijian", label: "Fijian" },
  { value: "filipino", label: "Filipino" },
  { value: "finnish", label: "Finnish" },
  { value: "french", label: "French" },
  { value: "gabonese", label: "Gabonese" },
  { value: "gambian", label: "Gambian" },
  { value: "georgian", label: "Georgian" },
  { value: "german", label: "German" },
  { value: "ghanaian", label: "Ghanaian" },
  { value: "greek", label: "Greek" },
  { value: "grenadian", label: "Grenadian" },
  { value: "guatemalan", label: "Guatemalan" },
  { value: "guinea-bissauan", label: "Guinea-Bissauan" },
  { value: "guinean", label: "Guinean" },
  { value: "guyanese", label: "Guyanese" },
  { value: "haitian", label: "Haitian" },
  { value: "herzegovinian", label: "Herzegovinian" },
  { value: "honduran", label: "Honduran" },
  { value: "hungarian", label: "Hungarian" },
  { value: "icelander", label: "Icelander" },
  { value: "indian", label: "Indian" },
  { value: "indonesian", label: "Indonesian" },
  { value: "iranian", label: "Iranian" },
  { value: "iraqi", label: "Iraqi" },
  { value: "irish", label: "Irish" },
  { value: "israeli", label: "Israeli" },
  { value: "italian", label: "Italian" },
  { value: "ivorian", label: "Ivorian" },
  { value: "jamaican", label: "Jamaican" },
  { value: "japanese", label: "Japanese" },
  { value: "jordanian", label: "Jordanian" },
  { value: "kazakhstani", label: "Kazakhstani" },
  { value: "kenyan", label: "Kenyan" },
  { value: "kittian and nevisian", label: "Kittian and Nevisian" },
  { value: "kuwaiti", label: "Kuwaiti" },
  { value: "kyrgyz", label: "Kyrgyz" },
  { value: "laotian", label: "Laotian" },
  { value: "latvian", label: "Latvian" },
  { value: "lebanese", label: "Lebanese" },
  { value: "liberian", label: "Liberian" },
  { value: "libyan", label: "Libyan" },
  { value: "liechtensteiner", label: "Liechtensteiner" },
  { value: "lithuanian", label: "Lithuanian" },
  { value: "luxembourger", label: "Luxembourger" },
  { value: "macedonian", label: "Macedonian" },
  { value: "malagasy", label: "Malagasy" },
  { value: "malawian", label: "Malawian" },
  { value: "malaysian", label: "Malaysian" },
  { value: "maldivan", label: "Maldivan" },
  { value: "malian", label: "Malian" },
  { value: "maltese", label: "Maltese" },
  { value: "marshallese", label: "Marshallese" },
  { value: "mauritanian", label: "Mauritanian" },
  { value: "mauritian", label: "Mauritian" },
  { value: "mexican", label: "Mexican" },
  { value: "micronesian", label: "Micronesian" },
  { value: "moldovan", label: "Moldovan" },
  { value: "monacan", label: "Monacan" },
  { value: "mongolian", label: "Mongolian" },
  { value: "moroccan", label: "Moroccan" },
  { value: "mosotho", label: "Mosotho" },
  { value: "motswana", label: "Motswana" },
  { value: "mozambican", label: "Mozambican" },
  { value: "namibian", label: "Namibian" },
  { value: "nauruan", label: "Nauruan" },
  { value: "nepalese", label: "Nepalese" },
  { value: "new zealander", label: "New Zealander" },
  { value: "ni-vanuatu", label: "Ni-Vanuatu" },
  { value: "nicaraguan", label: "Nicaraguan" },
  { value: "nigerien", label: "Nigerien" },
  { value: "north korean", label: "North Korean" },
  { value: "northern irish", label: "Northern Irish" },
  { value: "norwegian", label: "Norwegian" },
  { value: "omani", label: "Omani" },
  { value: "pakistani", label: "Pakistani" },
  { value: "palauan", label: "Palauan" },
  { value: "panamanian", label: "Panamanian" },
  { value: "papua new guinean", label: "Papua New Guinean" },
  { value: "paraguayan", label: "Paraguayan" },
  { value: "peruvian", label: "Peruvian" },
  { value: "polish", label: "Polish" },
  { value: "portuguese", label: "Portuguese" },
  { value: "qatari", label: "Qatari" },
  { value: "romanian", label: "Romanian" },
  { value: "russian", label: "Russian" },
  { value: "rwandan", label: "Rwandan" },
  { value: "saint lucian", label: "Saint Lucian" },
  { value: "salvadoran", label: "Salvadoran" },
  { value: "samoan", label: "Samoan" },
  { value: "san marinese", label: "San Marinese" },
  { value: "sao tomean", label: "Sao Tomean" },
  { value: "saudi", label: "Saudi" },
  { value: "scottish", label: "Scottish" },
  { value: "senegalese", label: "Senegalese" },
  { value: "serbian", label: "Serbian" },
  { value: "seychellois", label: "Seychellois" },
  { value: "sierra leonean", label: "Sierra Leonean" },
  { value: "singaporean", label: "Singaporean" },
  { value: "slovakian", label: "Slovakian" },
  { value: "slovenian", label: "Slovenian" },
  { value: "solomon islander", label: "Solomon Islander" },
  { value: "somali", label: "Somali" },
  { value: "south african", label: "South African" },
  { value: "south korean", label: "South Korean" },
  { value: "spanish", label: "Spanish" },
  { value: "sri lankan", label: "Sri Lankan" },
  { value: "sudanese", label: "Sudanese" },
  { value: "surinamer", label: "Surinamer" },
  { value: "swazi", label: "Swazi" },
  { value: "swedish", label: "Swedish" },
  { value: "swiss", label: "Swiss" },
  { value: "syrian", label: "Syrian" },
  { value: "taiwanese", label: "Taiwanese" },
  { value: "tajik", label: "Tajik" },
  { value: "tanzanian", label: "Tanzanian" },
  { value: "thai", label: "Thai" },
  { value: "togolese", label: "Togolese" },
  { value: "tongan", label: "Tongan" },
  { value: "trinidadian or tobagonian", label: "Trinidadian or Tobagonian" },
  { value: "tunisian", label: "Tunisian" },
  { value: "turkish", label: "Turkish" },
  { value: "tuvaluan", label: "Tuvaluan" },
  { value: "ugandan", label: "Ugandan" },
  { value: "ukrainian", label: "Ukrainian" },
  { value: "uruguayan", label: "Uruguayan" },
  { value: "uzbekistani", label: "Uzbekistani" },
  { value: "venezuelan", label: "Venezuelan" },
  { value: "vietnamese", label: "Vietnamese" },
  { value: "welsh", label: "Welsh" },
  { value: "yemenite", label: "Yemenite" },
  { value: "zambian", label: "Zambian" },
  { value: "zimbabwean", label: "Zimbabwean" },
];

export const ROLES = [
  {
    value: "manager",
    label: "Manager",
  },
  {
    value: "readOnly",
    label: "Read-Only",
  },
  {
    value: "paymentOnly",
    label: "Payment Only",
  },
];

export const NATIONALITY = [
  {
    value: "afghan",
    label: "Afghan",
  },
  {
    value: "albanian",
    label: "Albanian",
  },
  {
    value: "australian",
    label: "Australian",
  },
  {
    value: "bangladeshi",
    label: "Bangladeshi",
  },
  {
    value: "brazilian",
    label: "Brazilian",
  },
  {
    value: "bulgarian",
    label: "Bulgarian",
  },
  {
    value: "canadian",
    label: "Canadian",
  },
  {
    value: "chinese",
    label: "Chinese",
  },
  {
    value: "colombian",
    label: "Colombian",
  },
  {
    value: "egyptian",
    label: "Egyptian",
  },
  {
    value: "english",
    label: "English",
  },
  {
    value: "french",
    label: "French",
  },
  {
    value: "german",
    label: "German",
  },
  {
    value: "greek",
    label: "Greek",
  },
  {
    value: "icelandic",
    label: "Icelandic",
  },
  {
    value: "indian",
    label: "Indian",
  },
  {
    value: "indonasian",
    label: "Indonasion",
  },
  {
    value: "iranian",
    label: "Iranian",
  },
  {
    value: "iraqi",
    label: "Iraqi",
  },
  {
    value: "irish",
    label: "Irish",
  },
  {
    value: "israeli",
    label: "Israeli",
  },
  {
    value: "japanese",
    label: "Japanese",
  },
  {
    value: "kuwaiti",
    label: "Kuwaiti",
  },
  {
    value: "lebanese",
    label: "Lebanese",
  },
  {
    value: "mexican",
    label: "Mexican",
  },
  {
    value: "moroocan",
    label: "Moroocan",
  },
  {
    value: "nigerian",
    label: "Nigerian",
  },
  {
    value: "pakistani",
    label: "Pakistani",
  },
  {
    value: "phillippine",
    label: "Phillippine",
  },
  {
    value: "romanian",
    label: "Romanian",
  },
  {
    value: "russian",
    label: "Russian",
  },
  {
    value: "saudi",
    label: "Saudi",
  },
  {
    value: "scottish",
    label: "Scottish",
  },
  {
    value: "singaporian",
    label: "Singaporian",
  },
  {
    value: "korean",
    label: "Korean",
  },

  {
    value: "spanish",
    label: "Spanish",
  },
  {
    value: "tajikistan",
    label: "tajikistan",
  },
  {
    value: "thai",
    label: "Thai",
  },
  {
    value: "turkish",
    label: "Turkish",
  },
  {
    value: "emairati",
    label: "Emairati",
  },
  {
    value: "welsh",
    label: "Welsh",
  },
  {
    value: "zambian",
    label: "Zambian",
  },
  {
    value: "zimbabwean",
    label: "Zimbabwean",
  },
];

export const MONTH_LIST = [
  {
    value: "January",
    label: "January",
  },
  {
    value: "February",
    label: "February",
  },
  {
    value: "March",
    label: "March",
  },
  {
    value: "April",
    label: "April",
  },
  {
    value: "May",
    label: "May",
  },
  {
    value: "June",
    label: "June",
  },
  {
    value: "July",
    label: "July",
  },
  {
    value: "August",
    label: "August",
  },
  {
    value: "September",
    label: "September",
  },
  {
    value: "October",
    label: "October",
  },
  {
    value: "November",
    label: "November",
  },
  {
    value: "December",
    label: "December",
  },
];

export const totalSchoolFeesReceivedVsPendingData = [
  {
    title: "Pending",
    value: 0,
    color: "#FF8373",
  },
  {
    title: "Received",
    value: 0,
    color: "#4F73C7",
  },
];

const arbitraryStackKey = "stack1";
// const secondaryStackKey = "stack2";
export const data = {
  labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
  datasets: [
    {
      stack: arbitraryStackKey,
      label: "Pending",
      backgroundColor: "#EDECFE",
      data: [0, -60000, -5000, 8000, -24999],
      borderRadius: 5,
    },
    {
      stack: arbitraryStackKey,
      label: "Received",
      data: [50000, 23000, 42300, 11700, 30000],
      backgroundColor: "#A3A1FB",
      borderRadius: 5,
    },
  ],
};

export const ADDSINGLESTUDENTNOTES = [
  "This will add single student to the schools' record",
  "You will be able to add, edit and delete the students record from student management page",
  "You will be able to view, add, edit and delete invoice details by going to student detail page",
];

export const ADDCSVSTUDENTSNOTES = [
  "This will upload all the students data present in the uploaded file to the school's record",
  "You will be able to add, edit and delete the students record from student management page",
  "You will be able to view, add, edit and delete invoice details by going to student detail page",
];

export const STUDENT_DETAIL_TABS = [
  {
    id: 0,
    value: "Personal Details",
  },
  {
    id: 1,
    value: "Parent Details",
  },
  {
    id: 2,
    value: "Contact",
  },
];

export const USER_DETAIL_TABS = [
  {
    id: 0,
    value: "Personal Details",
  },
  {
    id: 1,
    value: "Contact Details",
  },
];

export const DUMMY_USER = {
  firstName: "Mubashir",
  lastName: "Mubashir Ali",
  dob: "12-12-12",
  gender: "Male",
  emiratesId: "123-12231223423513-23",
  nationality: "Pakistani",
  religion: "Islam",
  email: "mubashir@gmail.com",
  phoneNumber: "+42324523423",
  otherNumber: "087869387872",
};

export const STUDENT_FILE_UPLOADER = [
  "This will upload all the sutdents data present in the uploaded file to the school's record",
  "You will be able to add, edit and delete the student's record from student summary page",
  "You will be able to view, add, edit and delete invoice details by going to student detail page",
];

export const COUNTRIESWITHFLAG = [
  {
    id: 1,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/AFG.png",
    iso: "AF",
    name: "AFGHANISTAN",
    nicename: "Afghanistan",
    iso3: "AFG",
    numcode: "4",
    phonecode: "93",
  },
  {
    id: 2,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/ALB.png",
    iso: "AL",
    name: "ALBANIA",
    nicename: "Albania",
    iso3: "ALB",
    numcode: "8",
    phonecode: "355",
  },
  {
    id: 3,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/DZA.png",
    iso: "DZ",
    name: "ALGERIA",
    nicename: "Algeria",
    iso3: "DZA",
    numcode: "12",
    phonecode: "213",
  },
  {
    id: 4,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/ASM.png",
    iso: "AS",
    name: "AMERICAN SAMOA",
    nicename: "American Samoa",
    iso3: "ASM",
    numcode: "16",
    phonecode: "1684",
  },
  {
    id: 5,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/AND.png",
    iso: "AD",
    name: "ANDORRA",
    nicename: "Andorra",
    iso3: "AND",
    numcode: "20",
    phonecode: "376",
  },
  {
    id: 6,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/AGO.png",
    iso: "AO",
    name: "ANGOLA",
    nicename: "Angola",
    iso3: "AGO",
    numcode: "24",
    phonecode: "244",
  },
  {
    id: 7,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/AIA.png",
    iso: "AI",
    name: "ANGUILLA",
    nicename: "Anguilla",
    iso3: "AIA",
    numcode: "660",
    phonecode: "1264",
  },
  {
    id: 8,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/Antarctica.png",
    iso: "AQ",
    name: "ANTARCTICA",
    nicename: "Antarctica",
    iso3: null,
    numcode: null,
    phonecode: "0",
  },
  {
    id: 9,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/ATG.png",
    iso: "AG",
    name: "ANTIGUA AND BARBUDA",
    nicename: "Antigua and Barbuda",
    iso3: "ATG",
    numcode: "28",
    phonecode: "1268",
  },
  {
    id: 10,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/ARG.png",
    iso: "AR",
    name: "ARGENTINA",
    nicename: "Argentina",
    iso3: "ARG",
    numcode: "32",
    phonecode: "54",
  },
  {
    id: 11,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/ARM.png",
    iso: "AM",
    name: "ARMENIA",
    nicename: "Armenia",
    iso3: "ARM",
    numcode: "51",
    phonecode: "374",
  },
  {
    id: 12,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/ABW.png",
    iso: "AW",
    name: "ARUBA",
    nicename: "Aruba",
    iso3: "ABW",
    numcode: "533",
    phonecode: "297",
  },
  {
    id: 13,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/AUS.png",
    iso: "AU",
    name: "AUSTRALIA",
    nicename: "Australia",
    iso3: "AUS",
    numcode: "36",
    phonecode: "61",
  },
  {
    id: 14,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/AUT.png",
    iso: "AT",
    name: "AUSTRIA",
    nicename: "Austria",
    iso3: "AUT",
    numcode: "40",
    phonecode: "43",
  },
  {
    id: 15,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/AZE.png",
    iso: "AZ",
    name: "AZERBAIJAN",
    nicename: "Azerbaijan",
    iso3: "AZE",
    numcode: "31",
    phonecode: "994",
  },
  {
    id: 16,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/BHS.png",
    iso: "BS",
    name: "BAHAMAS",
    nicename: "Bahamas",
    iso3: "BHS",
    numcode: "44",
    phonecode: "1242",
  },
  {
    id: 17,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/BHR.png",
    iso: "BH",
    name: "BAHRAIN",
    nicename: "Bahrain",
    iso3: "BHR",
    numcode: "48",
    phonecode: "973",
  },
  {
    id: 18,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/BGD.png",
    iso: "BD",
    name: "BANGLADESH",
    nicename: "Bangladesh",
    iso3: "BGD",
    numcode: "50",
    phonecode: "880",
  },
  {
    id: 19,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/BRB.png",
    iso: "BB",
    name: "BARBADOS",
    nicename: "Barbados",
    iso3: "BRB",
    numcode: "52",
    phonecode: "1246",
  },
  {
    id: 20,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/BLR.png",
    iso: "BY",
    name: "BELARUS",
    nicename: "Belarus",
    iso3: "BLR",
    numcode: "112",
    phonecode: "375",
  },
  {
    id: 21,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/BEL.png",
    iso: "BE",
    name: "BELGIUM",
    nicename: "Belgium",
    iso3: "BEL",
    numcode: "56",
    phonecode: "32",
  },
  {
    id: 22,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/BLZ.png",
    iso: "BZ",
    name: "BELIZE",
    nicename: "Belize",
    iso3: "BLZ",
    numcode: "84",
    phonecode: "501",
  },
  {
    id: 23,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/BEN.png",
    iso: "BJ",
    name: "BENIN",
    nicename: "Benin",
    iso3: "BEN",
    numcode: "204",
    phonecode: "229",
  },
  {
    id: 24,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/BMU.png",
    iso: "BM",
    name: "BERMUDA",
    nicename: "Bermuda",
    iso3: "BMU",
    numcode: "60",
    phonecode: "1441",
  },
  {
    id: 25,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/BTN.png",
    iso: "BT",
    name: "BHUTAN",
    nicename: "Bhutan",
    iso3: "BTN",
    numcode: "64",
    phonecode: "975",
  },
  {
    id: 26,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/BOL.png",
    iso: "BO",
    name: "BOLIVIA",
    nicename: "Bolivia",
    iso3: "BOL",
    numcode: "68",
    phonecode: "591",
  },
  {
    id: 27,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/BIH.png",
    iso: "BA",
    name: "BOSNIA AND HERZEGOVINA",
    nicename: "Bosnia and Herzegovina",
    iso3: "BIH",
    numcode: "70",
    phonecode: "387",
  },
  {
    id: 28,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/BWA.png",
    iso: "BW",
    name: "BOTSWANA",
    nicename: "Botswana",
    iso3: "BWA",
    numcode: "72",
    phonecode: "267",
  },
  {
    id: 29,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/Bouvet-Island.png",
    iso: "BV",
    name: "BOUVET ISLAND",
    nicename: "Bouvet Island",
    iso3: null,
    numcode: null,
    phonecode: "0",
  },
  {
    id: 30,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/BRA.png",
    iso: "BR",
    name: "BRAZIL",
    nicename: "Brazil",
    iso3: "BRA",
    numcode: "76",
    phonecode: "55",
  },
  {
    id: 31,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/British-Territory.png",
    iso: "IO",
    name: "BRITISH INDIAN OCEAN TERRITORY",
    nicename: "British Indian Ocean Territory",
    iso3: null,
    numcode: null,
    phonecode: "246",
  },
  {
    id: 32,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/BRN.png",
    iso: "BN",
    name: "BRUNEI DARUSSALAM",
    nicename: "Brunei Darussalam",
    iso3: "BRN",
    numcode: "96",
    phonecode: "673",
  },
  {
    id: 33,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/BGR.png",
    iso: "BG",
    name: "BULGARIA",
    nicename: "Bulgaria",
    iso3: "BGR",
    numcode: "100",
    phonecode: "359",
  },
  {
    id: 34,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/BFA.png",
    iso: "BF",
    name: "BURKINA FASO",
    nicename: "Burkina Faso",
    iso3: "BFA",
    numcode: "854",
    phonecode: "226",
  },
  {
    id: 35,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/BDI.png",
    iso: "BI",
    name: "BURUNDI",
    nicename: "Burundi",
    iso3: "BDI",
    numcode: "108",
    phonecode: "257",
  },
  {
    id: 36,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/KHM.png",
    iso: "KH",
    name: "CAMBODIA",
    nicename: "Cambodia",
    iso3: "KHM",
    numcode: "116",
    phonecode: "855",
  },
  {
    id: 37,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/CMR.png",
    iso: "CM",
    name: "CAMEROON",
    nicename: "Cameroon",
    iso3: "CMR",
    numcode: "120",
    phonecode: "237",
  },
  {
    id: 38,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/CAN.png",
    iso: "CA",
    name: "CANADA",
    nicename: "Canada",
    iso3: "CAN",
    numcode: "124",
    phonecode: "1",
  },
  {
    id: 39,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/CPV.png",
    iso: "CV",
    name: "CAPE VERDE",
    nicename: "Cape Verde",
    iso3: "CPV",
    numcode: "132",
    phonecode: "238",
  },
  {
    id: 40,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/CYM.png",
    iso: "KY",
    name: "CAYMAN ISLANDS",
    nicename: "Cayman Islands",
    iso3: "CYM",
    numcode: "136",
    phonecode: "1345",
  },
  {
    id: 41,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/CAF.png",
    iso: "CF",
    name: "CENTRAL AFRICAN REPUBLIC",
    nicename: "Central African Republic",
    iso3: "CAF",
    numcode: "140",
    phonecode: "236",
  },
  {
    id: 42,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/TCD.png",
    iso: "TD",
    name: "CHAD",
    nicename: "Chad",
    iso3: "TCD",
    numcode: "148",
    phonecode: "235",
  },
  {
    id: 43,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/CHL.png",
    iso: "CL",
    name: "CHILE",
    nicename: "Chile",
    iso3: "CHL",
    numcode: "152",
    phonecode: "56",
  },
  {
    id: 44,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/CHN.png",
    iso: "CN",
    name: "CHINA",
    nicename: "China",
    iso3: "CHN",
    numcode: "156",
    phonecode: "86",
  },
  {
    id: 45,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/Christmas-Island.png",
    iso: "CX",
    name: "CHRISTMAS ISLAND",
    nicename: "Christmas Island",
    iso3: null,
    numcode: null,
    phonecode: "61",
  },
  {
    id: 46,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/Cocos-Islands.png",
    iso: "CC",
    name: "COCOS (KEELING) ISLANDS",
    nicename: "Cocos (Keeling) Islands",
    iso3: null,
    numcode: null,
    phonecode: "672",
  },
  {
    id: 47,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/COL.png",
    iso: "CO",
    name: "COLOMBIA",
    nicename: "Colombia",
    iso3: "COL",
    numcode: "170",
    phonecode: "57",
  },
  {
    id: 48,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/COM.png",
    iso: "KM",
    name: "COMOROS",
    nicename: "Comoros",
    iso3: "COM",
    numcode: "174",
    phonecode: "269",
  },
  {
    id: 49,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/COG.png",
    iso: "CG",
    name: "CONGO",
    nicename: "Congo",
    iso3: "COG",
    numcode: "178",
    phonecode: "242",
  },
  {
    id: 50,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/COD.png",
    iso: "CD",
    name: "CONGO, THE DEMOCRATIC REPUBLIC OF THE",
    nicename: "Congo, the Democratic Republic of the",
    iso3: "COD",
    numcode: "180",
    phonecode: "242",
  },
  {
    id: 51,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/COK.png",
    iso: "CK",
    name: "COOK ISLANDS",
    nicename: "Cook Islands",
    iso3: "COK",
    numcode: "184",
    phonecode: "682",
  },
  {
    id: 52,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/CRI.png",
    iso: "CR",
    name: "COSTA RICA",
    nicename: "Costa Rica",
    iso3: "CRI",
    numcode: "188",
    phonecode: "506",
  },
  {
    id: 53,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/CIV.png",
    iso: "CI",
    name: "COTE D'IVOIRE",
    nicename: "Cote D'Ivoire",
    iso3: "CIV",
    numcode: "384",
    phonecode: "225",
  },
  {
    id: 54,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/HRV.png",
    iso: "HR",
    name: "CROATIA",
    nicename: "Croatia",
    iso3: "HRV",
    numcode: "191",
    phonecode: "385",
  },
  {
    id: 55,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/CUB.png",
    iso: "CU",
    name: "CUBA",
    nicename: "Cuba",
    iso3: "CUB",
    numcode: "192",
    phonecode: "53",
  },
  {
    id: 56,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/CYP.png",
    iso: "CY",
    name: "CYPRUS",
    nicename: "Cyprus",
    iso3: "CYP",
    numcode: "196",
    phonecode: "357",
  },
  {
    id: 57,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/CZE.png",
    iso: "CZ",
    name: "CZECH REPUBLIC",
    nicename: "Czech Republic",
    iso3: "CZE",
    numcode: "203",
    phonecode: "420",
  },
  {
    id: 58,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/DNK.png",
    iso: "DK",
    name: "DENMARK",
    nicename: "Denmark",
    iso3: "DNK",
    numcode: "208",
    phonecode: "45",
  },
  {
    id: 59,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/DJI.png",
    iso: "DJ",
    name: "DJIBOUTI",
    nicename: "Djibouti",
    iso3: "DJI",
    numcode: "262",
    phonecode: "253",
  },
  {
    id: 60,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/DMA.png",
    iso: "DM",
    name: "DOMINICA",
    nicename: "Dominica",
    iso3: "DMA",
    numcode: "212",
    phonecode: "1767",
  },
  {
    id: 61,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/DOM.png",
    iso: "DO",
    name: "DOMINICAN REPUBLIC",
    nicename: "Dominican Republic",
    iso3: "DOM",
    numcode: "214",
    phonecode: "1809",
  },
  {
    id: 62,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/ECU.png",
    iso: "EC",
    name: "ECUADOR",
    nicename: "Ecuador",
    iso3: "ECU",
    numcode: "218",
    phonecode: "593",
  },
  {
    id: 63,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/EGY.png",
    iso: "EG",
    name: "EGYPT",
    nicename: "Egypt",
    iso3: "EGY",
    numcode: "818",
    phonecode: "20",
  },
  {
    id: 64,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/SLV.png",
    iso: "SV",
    name: "EL SALVADOR",
    nicename: "El Salvador",
    iso3: "SLV",
    numcode: "222",
    phonecode: "503",
  },
  {
    id: 65,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/GNQ.png",
    iso: "GQ",
    name: "EQUATORIAL GUINEA",
    nicename: "Equatorial Guinea",
    iso3: "GNQ",
    numcode: "226",
    phonecode: "240",
  },
  {
    id: 66,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/ERI.png",
    iso: "ER",
    name: "ERITREA",
    nicename: "Eritrea",
    iso3: "ERI",
    numcode: "232",
    phonecode: "291",
  },
  {
    id: 67,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/EST.png",
    iso: "EE",
    name: "ESTONIA",
    nicename: "Estonia",
    iso3: "EST",
    numcode: "233",
    phonecode: "372",
  },
  {
    id: 68,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/ETH.png",
    iso: "ET",
    name: "ETHIOPIA",
    nicename: "Ethiopia",
    iso3: "ETH",
    numcode: "231",
    phonecode: "251",
  },
  {
    id: 69,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/FLK.png",
    iso: "FK",
    name: "FALKLAND ISLANDS (MALVINAS)",
    nicename: "Falkland Islands (Malvinas)",
    iso3: "FLK",
    numcode: "238",
    phonecode: "500",
  },
  {
    id: 70,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/FRO.png",
    iso: "FO",
    name: "FAROE ISLANDS",
    nicename: "Faroe Islands",
    iso3: "FRO",
    numcode: "234",
    phonecode: "298",
  },
  {
    id: 71,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/FJI.png",
    iso: "FJ",
    name: "FIJI",
    nicename: "Fiji",
    iso3: "FJI",
    numcode: "242",
    phonecode: "679",
  },
  {
    id: 72,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/FIN.png",
    iso: "FI",
    name: "FINLAND",
    nicename: "Finland",
    iso3: "FIN",
    numcode: "246",
    phonecode: "358",
  },
  {
    id: 73,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/FRA.png",
    iso: "FR",
    name: "FRANCE",
    nicename: "France",
    iso3: "FRA",
    numcode: "250",
    phonecode: "33",
  },
  {
    id: 74,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/GUF.png",
    iso: "GF",
    name: "FRENCH GUIANA",
    nicename: "French Guiana",
    iso3: "GUF",
    numcode: "254",
    phonecode: "594",
  },
  {
    id: 75,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/PYF.png",
    iso: "PF",
    name: "FRENCH POLYNESIA",
    nicename: "French Polynesia",
    iso3: "PYF",
    numcode: "258",
    phonecode: "689",
  },
  {
    id: 76,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/French-Territories.png",
    iso: "TF",
    name: "FRENCH SOUTHERN TERRITORIES",
    nicename: "French Southern Territories",
    iso3: null,
    numcode: null,
    phonecode: "0",
  },
  {
    id: 77,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/GAB.png",
    iso: "GA",
    name: "GABON",
    nicename: "Gabon",
    iso3: "GAB",
    numcode: "266",
    phonecode: "241",
  },
  {
    id: 78,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/GMB.png",
    iso: "GM",
    name: "GAMBIA",
    nicename: "Gambia",
    iso3: "GMB",
    numcode: "270",
    phonecode: "220",
  },
  {
    id: 79,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/GEO.png",
    iso: "GE",
    name: "GEORGIA",
    nicename: "Georgia",
    iso3: "GEO",
    numcode: "268",
    phonecode: "995",
  },
  {
    id: 80,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/DEU.png",
    iso: "DE",
    name: "GERMANY",
    nicename: "Germany",
    iso3: "DEU",
    numcode: "276",
    phonecode: "49",
  },
  {
    id: 81,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/GHA.png",
    iso: "GH",
    name: "GHANA",
    nicename: "Ghana",
    iso3: "GHA",
    numcode: "288",
    phonecode: "233",
  },
  {
    id: 82,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/GIB.png",
    iso: "GI",
    name: "GIBRALTAR",
    nicename: "Gibraltar",
    iso3: "GIB",
    numcode: "292",
    phonecode: "350",
  },
  {
    id: 83,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/GRC.png",
    iso: "GR",
    name: "GREECE",
    nicename: "Greece",
    iso3: "GRC",
    numcode: "300",
    phonecode: "30",
  },
  {
    id: 84,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/GRL.png",
    iso: "GL",
    name: "GREENLAND",
    nicename: "Greenland",
    iso3: "GRL",
    numcode: "304",
    phonecode: "299",
  },
  {
    id: 85,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/GRD.png",
    iso: "GD",
    name: "GRENADA",
    nicename: "Grenada",
    iso3: "GRD",
    numcode: "308",
    phonecode: "1473",
  },
  {
    id: 86,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/GLP.png",
    iso: "GP",
    name: "GUADELOUPE",
    nicename: "Guadeloupe",
    iso3: "GLP",
    numcode: "312",
    phonecode: "590",
  },
  {
    id: 87,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/GUM.png",
    iso: "GU",
    name: "GUAM",
    nicename: "Guam",
    iso3: "GUM",
    numcode: "316",
    phonecode: "1671",
  },
  {
    id: 88,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/GTM.png",
    iso: "GT",
    name: "GUATEMALA",
    nicename: "Guatemala",
    iso3: "GTM",
    numcode: "320",
    phonecode: "502",
  },
  {
    id: 89,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/GIN.png",
    iso: "GN",
    name: "GUINEA",
    nicename: "Guinea",
    iso3: "GIN",
    numcode: "324",
    phonecode: "224",
  },
  {
    id: 90,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/GNB.png",
    iso: "GW",
    name: "GUINEA-BISSAU",
    nicename: "Guinea-Bissau",
    iso3: "GNB",
    numcode: "624",
    phonecode: "245",
  },
  {
    id: 91,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/GUY.png",
    iso: "GY",
    name: "GUYANA",
    nicename: "Guyana",
    iso3: "GUY",
    numcode: "328",
    phonecode: "592",
  },
  {
    id: 92,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/HTI.png",
    iso: "HT",
    name: "HAITI",
    nicename: "Haiti",
    iso3: "HTI",
    numcode: "332",
    phonecode: "509",
  },
  {
    id: 93,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/Heard-Islands.png",
    iso: "HM",
    name: "HEARD ISLAND AND MCDONALD ISLANDS",
    nicename: "Heard Island and Mcdonald Islands",
    iso3: null,
    numcode: null,
    phonecode: "0",
  },
  {
    id: 94,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/VAT.png",
    iso: "VA",
    name: "HOLY SEE (VATICAN CITY STATE)",
    nicename: "Holy See (Vatican City State)",
    iso3: "VAT",
    numcode: "336",
    phonecode: "39",
  },
  {
    id: 95,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/HND.png",
    iso: "HN",
    name: "HONDURAS",
    nicename: "Honduras",
    iso3: "HND",
    numcode: "340",
    phonecode: "504",
  },
  {
    id: 96,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/HKG.png",
    iso: "HK",
    name: "HONG KONG",
    nicename: "Hong Kong",
    iso3: "HKG",
    numcode: "344",
    phonecode: "852",
  },
  {
    id: 97,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/HUN.png",
    iso: "HU",
    name: "HUNGARY",
    nicename: "Hungary",
    iso3: "HUN",
    numcode: "348",
    phonecode: "36",
  },
  {
    id: 98,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/ISL.png",
    iso: "IS",
    name: "ICELAND",
    nicename: "Iceland",
    iso3: "ISL",
    numcode: "352",
    phonecode: "354",
  },
  {
    id: 99,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/IND.png",
    iso: "IN",
    name: "INDIA",
    nicename: "India",
    iso3: "IND",
    numcode: "356",
    phonecode: "91",
  },
  {
    id: 100,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/IDN.png",
    iso: "ID",
    name: "INDONESIA",
    nicename: "Indonesia",
    iso3: "IDN",
    numcode: "360",
    phonecode: "62",
  },
  {
    id: 101,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/IRN.png",
    iso: "IR",
    name: "IRAN, ISLAMIC REPUBLIC OF",
    nicename: "Iran, Islamic Republic of",
    iso3: "IRN",
    numcode: "364",
    phonecode: "98",
  },
  {
    id: 102,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/IRQ.png",
    iso: "IQ",
    name: "IRAQ",
    nicename: "Iraq",
    iso3: "IRQ",
    numcode: "368",
    phonecode: "964",
  },
  {
    id: 103,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/IRL.png",
    iso: "IE",
    name: "IRELAND",
    nicename: "Ireland",
    iso3: "IRL",
    numcode: "372",
    phonecode: "353",
  },
  {
    id: 104,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/ISR.png",
    iso: "IL",
    name: "ISRAEL",
    nicename: "Israel",
    iso3: "ISR",
    numcode: "376",
    phonecode: "972",
  },
  {
    id: 105,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/ITA.png",
    iso: "IT",
    name: "ITALY",
    nicename: "Italy",
    iso3: "ITA",
    numcode: "380",
    phonecode: "39",
  },
  {
    id: 106,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/JAM.png",
    iso: "JM",
    name: "JAMAICA",
    nicename: "Jamaica",
    iso3: "JAM",
    numcode: "388",
    phonecode: "1876",
  },
  {
    id: 107,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/JPN.png",
    iso: "JP",
    name: "JAPAN",
    nicename: "Japan",
    iso3: "JPN",
    numcode: "392",
    phonecode: "81",
  },
  {
    id: 108,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/JOR.png",
    iso: "JO",
    name: "JORDAN",
    nicename: "Jordan",
    iso3: "JOR",
    numcode: "400",
    phonecode: "962",
  },
  {
    id: 109,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/KAZ.png",
    iso: "KZ",
    name: "KAZAKHSTAN",
    nicename: "Kazakhstan",
    iso3: "KAZ",
    numcode: "398",
    phonecode: "7",
  },
  {
    id: 110,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/KEN.png",
    iso: "KE",
    name: "KENYA",
    nicename: "Kenya",
    iso3: "KEN",
    numcode: "404",
    phonecode: "254",
  },
  {
    id: 111,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/KIR.png",
    iso: "KI",
    name: "KIRIBATI",
    nicename: "Kiribati",
    iso3: "KIR",
    numcode: "296",
    phonecode: "686",
  },
  {
    id: 112,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/PRK.png",
    iso: "KP",
    name: "KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF",
    nicename: "Korea, Democratic People's Republic of",
    iso3: "PRK",
    numcode: "408",
    phonecode: "850",
  },
  {
    id: 113,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/KOR.png",
    iso: "KR",
    name: "KOREA, REPUBLIC OF",
    nicename: "Korea, Republic of",
    iso3: "KOR",
    numcode: "410",
    phonecode: "82",
  },
  {
    id: 114,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/KWT.png",
    iso: "KW",
    name: "KUWAIT",
    nicename: "Kuwait",
    iso3: "KWT",
    numcode: "414",
    phonecode: "965",
  },
  {
    id: 115,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/KGZ.png",
    iso: "KG",
    name: "KYRGYZSTAN",
    nicename: "Kyrgyzstan",
    iso3: "KGZ",
    numcode: "417",
    phonecode: "996",
  },
  {
    id: 116,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/LAO.png",
    iso: "LA",
    name: "LAO PEOPLE'S DEMOCRATIC REPUBLIC",
    nicename: "Lao People's Democratic Republic",
    iso3: "LAO",
    numcode: "418",
    phonecode: "856",
  },
  {
    id: 117,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/LVA.png",
    iso: "LV",
    name: "LATVIA",
    nicename: "Latvia",
    iso3: "LVA",
    numcode: "428",
    phonecode: "371",
  },
  {
    id: 118,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/LBN.png",
    iso: "LB",
    name: "LEBANON",
    nicename: "Lebanon",
    iso3: "LBN",
    numcode: "422",
    phonecode: "961",
  },
  {
    id: 119,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/LSO.png",
    iso: "LS",
    name: "LESOTHO",
    nicename: "Lesotho",
    iso3: "LSO",
    numcode: "426",
    phonecode: "266",
  },
  {
    id: 120,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/LBR.png",
    iso: "LR",
    name: "LIBERIA",
    nicename: "Liberia",
    iso3: "LBR",
    numcode: "430",
    phonecode: "231",
  },
  {
    id: 121,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/LBY.png",
    iso: "LY",
    name: "LIBYAN ARAB JAMAHIRIYA",
    nicename: "Libyan Arab Jamahiriya",
    iso3: "LBY",
    numcode: "434",
    phonecode: "218",
  },
  {
    id: 122,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/LIE.png",
    iso: "LI",
    name: "LIECHTENSTEIN",
    nicename: "Liechtenstein",
    iso3: "LIE",
    numcode: "438",
    phonecode: "423",
  },
  {
    id: 123,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/LTU.png",
    iso: "LT",
    name: "LITHUANIA",
    nicename: "Lithuania",
    iso3: "LTU",
    numcode: "440",
    phonecode: "370",
  },
  {
    id: 124,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/LUX.png",
    iso: "LU",
    name: "LUXEMBOURG",
    nicename: "Luxembourg",
    iso3: "LUX",
    numcode: "442",
    phonecode: "352",
  },
  {
    id: 125,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/MAC.png",
    iso: "MO",
    name: "MACAO",
    nicename: "Macao",
    iso3: "MAC",
    numcode: "446",
    phonecode: "853",
  },
  {
    id: 126,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/MKD.png",
    iso: "MK",
    name: "MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF",
    nicename: "Macedonia, the Former Yugoslav Republic of",
    iso3: "MKD",
    numcode: "807",
    phonecode: "389",
  },
  {
    id: 127,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/MDG.png",
    iso: "MG",
    name: "MADAGASCAR",
    nicename: "Madagascar",
    iso3: "MDG",
    numcode: "450",
    phonecode: "261",
  },
  {
    id: 128,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/MWI.png",
    iso: "MW",
    name: "MALAWI",
    nicename: "Malawi",
    iso3: "MWI",
    numcode: "454",
    phonecode: "265",
  },
  {
    id: 129,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/MYS.png",
    iso: "MY",
    name: "MALAYSIA",
    nicename: "Malaysia",
    iso3: "MYS",
    numcode: "458",
    phonecode: "60",
  },
  {
    id: 130,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/MDV.png",
    iso: "MV",
    name: "MALDIVES",
    nicename: "Maldives",
    iso3: "MDV",
    numcode: "462",
    phonecode: "960",
  },
  {
    id: 131,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/MLI.png",
    iso: "ML",
    name: "MALI",
    nicename: "Mali",
    iso3: "MLI",
    numcode: "466",
    phonecode: "223",
  },
  {
    id: 132,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/MLT.png",
    iso: "MT",
    name: "MALTA",
    nicename: "Malta",
    iso3: "MLT",
    numcode: "470",
    phonecode: "356",
  },
  {
    id: 133,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/MHL.png",
    iso: "MH",
    name: "MARSHALL ISLANDS",
    nicename: "Marshall Islands",
    iso3: "MHL",
    numcode: "584",
    phonecode: "692",
  },
  {
    id: 134,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/MTQ.png",
    iso: "MQ",
    name: "MARTINIQUE",
    nicename: "Martinique",
    iso3: "MTQ",
    numcode: "474",
    phonecode: "596",
  },
  {
    id: 135,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/MRT.png",
    iso: "MR",
    name: "MAURITANIA",
    nicename: "Mauritania",
    iso3: "MRT",
    numcode: "478",
    phonecode: "222",
  },
  {
    id: 136,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/MUS.png",
    iso: "MU",
    name: "MAURITIUS",
    nicename: "Mauritius",
    iso3: "MUS",
    numcode: "480",
    phonecode: "230",
  },
  {
    id: 137,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/Mayotte.png",
    iso: "YT",
    name: "MAYOTTE",
    nicename: "Mayotte",
    iso3: null,
    numcode: null,
    phonecode: "269",
  },
  {
    id: 138,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/MEX.png",
    iso: "MX",
    name: "MEXICO",
    nicename: "Mexico",
    iso3: "MEX",
    numcode: "484",
    phonecode: "52",
  },
  {
    id: 139,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/FSM.png",
    iso: "FM",
    name: "MICRONESIA, FEDERATED STATES OF",
    nicename: "Micronesia, Federated States of",
    iso3: "FSM",
    numcode: "583",
    phonecode: "691",
  },
  {
    id: 140,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/MDA.png",
    iso: "MD",
    name: "MOLDOVA, REPUBLIC OF",
    nicename: "Moldova, Republic of",
    iso3: "MDA",
    numcode: "498",
    phonecode: "373",
  },
  {
    id: 141,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/MCO.png",
    iso: "MC",
    name: "MONACO",
    nicename: "Monaco",
    iso3: "MCO",
    numcode: "492",
    phonecode: "377",
  },
  {
    id: 142,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/MNG.png",
    iso: "MN",
    name: "MONGOLIA",
    nicename: "Mongolia",
    iso3: "MNG",
    numcode: "496",
    phonecode: "976",
  },
  {
    id: 143,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/MSR.png",
    iso: "MS",
    name: "MONTSERRAT",
    nicename: "Montserrat",
    iso3: "MSR",
    numcode: "500",
    phonecode: "1664",
  },
  {
    id: 144,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/MAR.png",
    iso: "MA",
    name: "MOROCCO",
    nicename: "Morocco",
    iso3: "MAR",
    numcode: "504",
    phonecode: "212",
  },
  {
    id: 145,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/MOZ.png",
    iso: "MZ",
    name: "MOZAMBIQUE",
    nicename: "Mozambique",
    iso3: "MOZ",
    numcode: "508",
    phonecode: "258",
  },
  {
    id: 146,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/MMR.png",
    iso: "MM",
    name: "MYANMAR",
    nicename: "Myanmar",
    iso3: "MMR",
    numcode: "104",
    phonecode: "95",
  },
  {
    id: 147,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/NAM.png",
    iso: "NA",
    name: "NAMIBIA",
    nicename: "Namibia",
    iso3: "NAM",
    numcode: "516",
    phonecode: "264",
  },
  {
    id: 148,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/NRU.png",
    iso: "NR",
    name: "NAURU",
    nicename: "Nauru",
    iso3: "NRU",
    numcode: "520",
    phonecode: "674",
  },
  {
    id: 149,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/NPL.png",
    iso: "NP",
    name: "NEPAL",
    nicename: "Nepal",
    iso3: "NPL",
    numcode: "524",
    phonecode: "977",
  },
  {
    id: 150,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/NLD.png",
    iso: "NL",
    name: "NETHERLANDS",
    nicename: "Netherlands",
    iso3: "NLD",
    numcode: "528",
    phonecode: "31",
  },
  {
    id: 151,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/ANT.png",
    iso: "AN",
    name: "NETHERLANDS ANTILLES",
    nicename: "Netherlands Antilles",
    iso3: "ANT",
    numcode: "530",
    phonecode: "599",
  },
  {
    id: 152,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/NCL.png",
    iso: "NC",
    name: "NEW CALEDONIA",
    nicename: "New Caledonia",
    iso3: "NCL",
    numcode: "540",
    phonecode: "687",
  },
  {
    id: 153,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/NZL.png",
    iso: "NZ",
    name: "NEW ZEALAND",
    nicename: "New Zealand",
    iso3: "NZL",
    numcode: "554",
    phonecode: "64",
  },
  {
    id: 154,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/NIC.png",
    iso: "NI",
    name: "NICARAGUA",
    nicename: "Nicaragua",
    iso3: "NIC",
    numcode: "558",
    phonecode: "505",
  },
  {
    id: 155,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/NER.png",
    iso: "NE",
    name: "NIGER",
    nicename: "Niger",
    iso3: "NER",
    numcode: "562",
    phonecode: "227",
  },
  {
    id: 156,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/NGA.png",
    iso: "NG",
    name: "NIGERIA",
    nicename: "Nigeria",
    iso3: "NGA",
    numcode: "566",
    phonecode: "234",
  },
  {
    id: 157,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/NIU.png",
    iso: "NU",
    name: "NIUE",
    nicename: "Niue",
    iso3: "NIU",
    numcode: "570",
    phonecode: "683",
  },
  {
    id: 158,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/NFK.png",
    iso: "NF",
    name: "NORFOLK ISLAND",
    nicename: "Norfolk Island",
    iso3: "NFK",
    numcode: "574",
    phonecode: "672",
  },
  {
    id: 159,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/MNP.png",
    iso: "MP",
    name: "NORTHERN MARIANA ISLANDS",
    nicename: "Northern Mariana Islands",
    iso3: "MNP",
    numcode: "580",
    phonecode: "1670",
  },
  {
    id: 160,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/NOR.png",
    iso: "NO",
    name: "NORWAY",
    nicename: "Norway",
    iso3: "NOR",
    numcode: "578",
    phonecode: "47",
  },
  {
    id: 161,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/OMN.png",
    iso: "OM",
    name: "OMAN",
    nicename: "Oman",
    iso3: "OMN",
    numcode: "512",
    phonecode: "968",
  },
  {
    id: 162,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/PAK.png",
    iso: "PK",
    name: "PAKISTAN",
    nicename: "Pakistan",
    iso3: "PAK",
    numcode: "586",
    phonecode: "92",
  },
  {
    id: 163,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/PLW.png",
    iso: "PW",
    name: "PALAU",
    nicename: "Palau",
    iso3: "PLW",
    numcode: "585",
    phonecode: "680",
  },
  {
    id: 164,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/Palestinian.png",
    iso: "PS",
    name: "PALESTINIAN TERRITORY, OCCUPIED",
    nicename: "Palestinian Territory, Occupied",
    iso3: null,
    numcode: null,
    phonecode: "970",
  },
  {
    id: 165,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/PAN.png",
    iso: "PA",
    name: "PANAMA",
    nicename: "Panama",
    iso3: "PAN",
    numcode: "591",
    phonecode: "507",
  },
  {
    id: 166,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/PNG.png",
    iso: "PG",
    name: "PAPUA NEW GUINEA",
    nicename: "Papua New Guinea",
    iso3: "PNG",
    numcode: "598",
    phonecode: "675",
  },
  {
    id: 167,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/PRY.png",
    iso: "PY",
    name: "PARAGUAY",
    nicename: "Paraguay",
    iso3: "PRY",
    numcode: "600",
    phonecode: "595",
  },
  {
    id: 168,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/PER.png",
    iso: "PE",
    name: "PERU",
    nicename: "Peru",
    iso3: "PER",
    numcode: "604",
    phonecode: "51",
  },
  {
    id: 169,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/PHL.png",
    iso: "PH",
    name: "PHILIPPINES",
    nicename: "Philippines",
    iso3: "PHL",
    numcode: "608",
    phonecode: "63",
  },
  {
    id: 170,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/PCN.png",
    iso: "PN",
    name: "PITCAIRN",
    nicename: "Pitcairn",
    iso3: "PCN",
    numcode: "612",
    phonecode: "0",
  },
  {
    id: 171,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/POL.png",
    iso: "PL",
    name: "POLAND",
    nicename: "Poland",
    iso3: "POL",
    numcode: "616",
    phonecode: "48",
  },
  {
    id: 172,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/PRT.png",
    iso: "PT",
    name: "PORTUGAL",
    nicename: "Portugal",
    iso3: "PRT",
    numcode: "620",
    phonecode: "351",
  },
  {
    id: 173,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/PRI.png",
    iso: "PR",
    name: "PUERTO RICO",
    nicename: "Puerto Rico",
    iso3: "PRI",
    numcode: "630",
    phonecode: "1787",
  },
  {
    id: 174,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/QAT.png",
    iso: "QA",
    name: "QATAR",
    nicename: "Qatar",
    iso3: "QAT",
    numcode: "634",
    phonecode: "974",
  },
  {
    id: 175,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/REU.png",
    iso: "RE",
    name: "REUNION",
    nicename: "Reunion",
    iso3: "REU",
    numcode: "638",
    phonecode: "262",
  },
  {
    id: 176,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/ROM.png",
    iso: "RO",
    name: "ROMANIA",
    nicename: "Romania",
    iso3: "ROM",
    numcode: "642",
    phonecode: "40",
  },
  {
    id: 177,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/RUS.png",
    iso: "RU",
    name: "RUSSIAN FEDERATION",
    nicename: "Russian Federation",
    iso3: "RUS",
    numcode: "643",
    phonecode: "70",
  },
  {
    id: 178,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/RWA.png",
    iso: "RW",
    name: "RWANDA",
    nicename: "Rwanda",
    iso3: "RWA",
    numcode: "646",
    phonecode: "250",
  },
  {
    id: 179,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/SHN.png",
    iso: "SH",
    name: "SAINT HELENA",
    nicename: "Saint Helena",
    iso3: "SHN",
    numcode: "654",
    phonecode: "290",
  },
  {
    id: 180,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/KNA.png",
    iso: "KN",
    name: "SAINT KITTS AND NEVIS",
    nicename: "Saint Kitts and Nevis",
    iso3: "KNA",
    numcode: "659",
    phonecode: "1869",
  },
  {
    id: 181,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/LCA.png",
    iso: "LC",
    name: "SAINT LUCIA",
    nicename: "Saint Lucia",
    iso3: "LCA",
    numcode: "662",
    phonecode: "1758",
  },
  {
    id: 182,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/SPM.png",
    iso: "PM",
    name: "SAINT PIERRE AND MIQUELON",
    nicename: "Saint Pierre and Miquelon",
    iso3: "SPM",
    numcode: "666",
    phonecode: "508",
  },
  {
    id: 183,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/VCT.png",
    iso: "VC",
    name: "SAINT VINCENT AND THE GRENADINES",
    nicename: "Saint Vincent and the Grenadines",
    iso3: "VCT",
    numcode: "670",
    phonecode: "1784",
  },
  {
    id: 184,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/WSM.png",
    iso: "WS",
    name: "SAMOA",
    nicename: "Samoa",
    iso3: "WSM",
    numcode: "882",
    phonecode: "684",
  },
  {
    id: 185,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/SMR.png",
    iso: "SM",
    name: "SAN MARINO",
    nicename: "San Marino",
    iso3: "SMR",
    numcode: "674",
    phonecode: "378",
  },
  {
    id: 186,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/STP.png",
    iso: "ST",
    name: "SAO TOME AND PRINCIPE",
    nicename: "Sao Tome and Principe",
    iso3: "STP",
    numcode: "678",
    phonecode: "239",
  },
  {
    id: 187,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/SAU.png",
    iso: "SA",
    name: "SAUDI ARABIA",
    nicename: "Saudi Arabia",
    iso3: "SAU",
    numcode: "682",
    phonecode: "966",
  },
  {
    id: 188,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/SEN.png",
    iso: "SN",
    name: "SENEGAL",
    nicename: "Senegal",
    iso3: "SEN",
    numcode: "686",
    phonecode: "221",
  },
  {
    id: 189,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/Serbia-Montenegro.png",
    iso: "CS",
    name: "SERBIA AND MONTENEGRO",
    nicename: "Serbia and Montenegro",
    iso3: null,
    numcode: null,
    phonecode: "381",
  },
  {
    id: 190,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/SYC.png",
    iso: "SC",
    name: "SEYCHELLES",
    nicename: "Seychelles",
    iso3: "SYC",
    numcode: "690",
    phonecode: "248",
  },
  {
    id: 191,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/SLE.png",
    iso: "SL",
    name: "SIERRA LEONE",
    nicename: "Sierra Leone",
    iso3: "SLE",
    numcode: "694",
    phonecode: "232",
  },
  {
    id: 192,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/SGP.png",
    iso: "SG",
    name: "SINGAPORE",
    nicename: "Singapore",
    iso3: "SGP",
    numcode: "702",
    phonecode: "65",
  },
  {
    id: 193,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/SVK.png",
    iso: "SK",
    name: "SLOVAKIA",
    nicename: "Slovakia",
    iso3: "SVK",
    numcode: "703",
    phonecode: "421",
  },
  {
    id: 194,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/SVN.png",
    iso: "SI",
    name: "SLOVENIA",
    nicename: "Slovenia",
    iso3: "SVN",
    numcode: "705",
    phonecode: "386",
  },
  {
    id: 195,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/SLB.png",
    iso: "SB",
    name: "SOLOMON ISLANDS",
    nicename: "Solomon Islands",
    iso3: "SLB",
    numcode: "90",
    phonecode: "677",
  },
  {
    id: 196,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/SOM.png",
    iso: "SO",
    name: "SOMALIA",
    nicename: "Somalia",
    iso3: "SOM",
    numcode: "706",
    phonecode: "252",
  },
  {
    id: 197,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/ZAF.png",
    iso: "ZA",
    name: "SOUTH AFRICA",
    nicename: "South Africa",
    iso3: "ZAF",
    numcode: "710",
    phonecode: "27",
  },
  {
    id: 198,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/South-Georgia-Islands.png",
    iso: "GS",
    name: "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS",
    nicename: "South Georgia and the South Sandwich Islands",
    iso3: null,
    numcode: null,
    phonecode: "0",
  },
  {
    id: 199,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/ESP.png",
    iso: "ES",
    name: "SPAIN",
    nicename: "Spain",
    iso3: "ESP",
    numcode: "724",
    phonecode: "34",
  },
  {
    id: 200,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/LKA.png",
    iso: "LK",
    name: "SRI LANKA",
    nicename: "Sri Lanka",
    iso3: "LKA",
    numcode: "144",
    phonecode: "94",
  },
  {
    id: 201,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/SDN.png",
    iso: "SD",
    name: "SUDAN",
    nicename: "Sudan",
    iso3: "SDN",
    numcode: "736",
    phonecode: "249",
  },
  {
    id: 202,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/SUR.png",
    iso: "SR",
    name: "SURINAME",
    nicename: "Suriname",
    iso3: "SUR",
    numcode: "740",
    phonecode: "597",
  },
  {
    id: 203,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/SJM.png",
    iso: "SJ",
    name: "SVALBARD AND JAN MAYEN",
    nicename: "Svalbard and Jan Mayen",
    iso3: "SJM",
    numcode: "744",
    phonecode: "47",
  },
  {
    id: 204,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/SWZ.png",
    iso: "SZ",
    name: "SWAZILAND",
    nicename: "Swaziland",
    iso3: "SWZ",
    numcode: "748",
    phonecode: "268",
  },
  {
    id: 205,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/SWE.png",
    iso: "SE",
    name: "SWEDEN",
    nicename: "Sweden",
    iso3: "SWE",
    numcode: "752",
    phonecode: "46",
  },
  {
    id: 206,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/CHE.png",
    iso: "CH",
    name: "SWITZERLAND",
    nicename: "Switzerland",
    iso3: "CHE",
    numcode: "756",
    phonecode: "41",
  },
  {
    id: 207,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/SYR.png",
    iso: "SY",
    name: "SYRIAN ARAB REPUBLIC",
    nicename: "Syrian Arab Republic",
    iso3: "SYR",
    numcode: "760",
    phonecode: "963",
  },
  {
    id: 208,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/TWN.png",
    iso: "TW",
    name: "TAIWAN, PROVINCE OF CHINA",
    nicename: "Taiwan, Province of China",
    iso3: "TWN",
    numcode: "158",
    phonecode: "886",
  },
  {
    id: 209,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/TJK.png",
    iso: "TJ",
    name: "TAJIKISTAN",
    nicename: "Tajikistan",
    iso3: "TJK",
    numcode: "762",
    phonecode: "992",
  },
  {
    id: 210,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/TZA.png",
    iso: "TZ",
    name: "TANZANIA, UNITED REPUBLIC OF",
    nicename: "Tanzania, United Republic of",
    iso3: "TZA",
    numcode: "834",
    phonecode: "255",
  },
  {
    id: 211,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/THA.png",
    iso: "TH",
    name: "THAILAND",
    nicename: "Thailand",
    iso3: "THA",
    numcode: "764",
    phonecode: "66",
  },
  {
    id: 212,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/Timor-Leste.png",
    iso: "TL",
    name: "TIMOR-LESTE",
    nicename: "Timor-Leste",
    iso3: null,
    numcode: null,
    phonecode: "670",
  },
  {
    id: 213,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/TGO.png",
    iso: "TG",
    name: "TOGO",
    nicename: "Togo",
    iso3: "TGO",
    numcode: "768",
    phonecode: "228",
  },
  {
    id: 214,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/TKL.png",
    iso: "TK",
    name: "TOKELAU",
    nicename: "Tokelau",
    iso3: "TKL",
    numcode: "772",
    phonecode: "690",
  },
  {
    id: 215,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/TON.png",
    iso: "TO",
    name: "TONGA",
    nicename: "Tonga",
    iso3: "TON",
    numcode: "776",
    phonecode: "676",
  },
  {
    id: 216,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/TTO.png",
    iso: "TT",
    name: "TRINIDAD AND TOBAGO",
    nicename: "Trinidad and Tobago",
    iso3: "TTO",
    numcode: "780",
    phonecode: "1868",
  },
  {
    id: 217,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/TUN.png",
    iso: "TN",
    name: "TUNISIA",
    nicename: "Tunisia",
    iso3: "TUN",
    numcode: "788",
    phonecode: "216",
  },
  {
    id: 218,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/TUR.png",
    iso: "TR",
    name: "TURKEY",
    nicename: "Turkey",
    iso3: "TUR",
    numcode: "792",
    phonecode: "90",
  },
  {
    id: 219,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/TKM.png",
    iso: "TM",
    name: "TURKMENISTAN",
    nicename: "Turkmenistan",
    iso3: "TKM",
    numcode: "795",
    phonecode: "7370",
  },
  {
    id: 220,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/TCA.png",
    iso: "TC",
    name: "TURKS AND CAICOS ISLANDS",
    nicename: "Turks and Caicos Islands",
    iso3: "TCA",
    numcode: "796",
    phonecode: "1649",
  },
  {
    id: 221,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/TUV.png",
    iso: "TV",
    name: "TUVALU",
    nicename: "Tuvalu",
    iso3: "TUV",
    numcode: "798",
    phonecode: "688",
  },
  {
    id: 222,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/UGA.png",
    iso: "UG",
    name: "UGANDA",
    nicename: "Uganda",
    iso3: "UGA",
    numcode: "800",
    phonecode: "256",
  },
  {
    id: 223,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/UKR.png",
    iso: "UA",
    name: "UKRAINE",
    nicename: "Ukraine",
    iso3: "UKR",
    numcode: "804",
    phonecode: "380",
  },
  {
    id: 224,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/ARE.png",
    iso: "AE",
    name: "UNITED ARAB EMIRATES",
    nicename: "United Arab Emirates",
    iso3: "ARE",
    numcode: "784",
    phonecode: "971",
  },
  {
    id: 225,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/GBR.png",
    iso: "GB",
    name: "UNITED KINGDOM",
    nicename: "United Kingdom",
    iso3: "GBR",
    numcode: "826",
    phonecode: "44",
  },
  {
    id: 226,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/USA.png",
    iso: "US",
    name: "UNITED STATES",
    nicename: "United States",
    iso3: "USA",
    numcode: "840",
    phonecode: "1",
  },
  {
    id: 227,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/United-States-Minor-Islands.png",
    iso: "UM",
    name: "UNITED STATES MINOR OUTLYING ISLANDS",
    nicename: "United States Minor Outlying Islands",
    iso3: null,
    numcode: null,
    phonecode: "1",
  },
  {
    id: 228,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/URY.png",
    iso: "UY",
    name: "URUGUAY",
    nicename: "Uruguay",
    iso3: "URY",
    numcode: "858",
    phonecode: "598",
  },
  {
    id: 229,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/UZB.png",
    iso: "UZ",
    name: "UZBEKISTAN",
    nicename: "Uzbekistan",
    iso3: "UZB",
    numcode: "860",
    phonecode: "998",
  },
  {
    id: 230,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/VUT.png",
    iso: "VU",
    name: "VANUATU",
    nicename: "Vanuatu",
    iso3: "VUT",
    numcode: "548",
    phonecode: "678",
  },
  {
    id: 231,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/VEN.png",
    iso: "VE",
    name: "VENEZUELA",
    nicename: "Venezuela",
    iso3: "VEN",
    numcode: "862",
    phonecode: "58",
  },
  {
    id: 232,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/VNM.png",
    iso: "VN",
    name: "VIET NAM",
    nicename: "Viet Nam",
    iso3: "VNM",
    numcode: "704",
    phonecode: "84",
  },
  {
    id: 233,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/VGB.png",
    iso: "VG",
    name: "VIRGIN ISLANDS, BRITISH",
    nicename: "Virgin Islands, British",
    iso3: "VGB",
    numcode: "92",
    phonecode: "1284",
  },
  {
    id: 234,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/VIR.png",
    iso: "VI",
    name: "VIRGIN ISLANDS, U.S.",
    nicename: "Virgin Islands, U.s.",
    iso3: "VIR",
    numcode: "850",
    phonecode: "1340",
  },
  {
    id: 235,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/WLF.png",
    iso: "WF",
    name: "WALLIS AND FUTUNA",
    nicename: "Wallis and Futuna",
    iso3: "WLF",
    numcode: "876",
    phonecode: "681",
  },
  {
    id: 236,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/ESH.png",
    iso: "EH",
    name: "WESTERN SAHARA",
    nicename: "Western Sahara",
    iso3: "ESH",
    numcode: "732",
    phonecode: "212",
  },
  {
    id: 237,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/YEM.png",
    iso: "YE",
    name: "YEMEN",
    nicename: "Yemen",
    iso3: "YEM",
    numcode: "887",
    phonecode: "967",
  },
  {
    id: 238,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/ZMB.png",
    iso: "ZM",
    name: "ZAMBIA",
    nicename: "Zambia",
    iso3: "ZMB",
    numcode: "894",
    phonecode: "260",
  },
  {
    id: 239,
    flag: "https://discoveritech.com/border-pay/public/assets/images/countries/ZWE.png",
    iso: "ZW",
    name: "ZIMBABWE",
    nicename: "Zimbabwe",
    iso3: "ZWE",
    numcode: "716",
    phonecode: "263",
  },
];

export const USER_DETAIL_LOGS_DUMMY_DATA = [
  {
    id: 1,
    logDetail: "Upload invoice file to database",
    logDuration: "20 min ago",
  },
  {
    id: 2,
    logDetail: "Upload students file to database",
    logDuration: "52 min ago",
  },
  {
    id: 3,
    logDetail: "Removed student with ID VUA147058",
    logDuration: "Yesterday",
  },
  {
    id: 4,
    logDetail: "Added student with student ID VUA147058",
    logDuration: "Yesterday",
  },
];

export const titleCase = (str) => {
  return str
    .toLowerCase()
    .split(" ")
    .map(function (word) {
      return word.replace(word[0], word[0].toUpperCase());
    })
    .join(" ");
};
